// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"3e325743","239":"a126daf7","453":"078e0309","644":"c48ed49a","667":"bca717cd","762":"5ceabe88"}[chunkId] + ".chunk.js";
};